import { Type } from 'class-transformer';
import { ContactInfoCustomFieldRawDto } from './contact-info-custom-field-raw-dto';

export class ContactInfoRawDto {
  contactDetailId: number;
  contactId: number;
  contactTypeId: number;
  content: string;
  description: string;
  sequence: number;
  isPublished: boolean;
  subTypeId: string;
  @Type(() => ContactInfoCustomFieldRawDto)
  customFieldsData: Array<ContactInfoCustomFieldRawDto>;
  crudAction: string;
  isPrimary: boolean;
}
